import React from "react";
import { Select, Option } from "@clarkinc/zest-design-system";

type ReorderOptionGroupProps = {
  inputTestId: string;
  selectTestId: string;
  onRadioChange: React.ChangeEventHandler<HTMLInputElement>;
  onSelectChange:
    | (React.ChangeEventHandler<HTMLInputElement> &
        React.ChangeEventHandler<HTMLSelectElement>)
    | undefined;
  selectOptions: { value: string; label: string; disabled?: boolean }[];
  selectAriaLabel: string;
  defaultChecked?: boolean;
};

const ReorderOptionGroup = ({
  inputTestId,
  selectTestId,
  onRadioChange,
  onSelectChange,
  selectOptions,
  selectAriaLabel,
  defaultChecked = false,
}: ReorderOptionGroupProps) => {
  return (
    <div className="flex flex-row items-center border-none p-0">
      <div className="h-7 w-7 pl-2 flex items-center justify-center">
        <input
          aria-label={selectOptions[0]?.label}
          className="cursor-pointer h-6 w-6 m-0 appearance-none rounded-full border-solid border-gray-600 checked:border-green-500 bg-white checked:bg-green-500 border-[2px] checked:border-[3px] shadow-[0_0_0_2px_inset_white] hover:ring-4 ring-green-100"
          type="radio"
          name="subscription"
          data-testid={inputTestId}
          onChange={onRadioChange}
          value="newAutoReorder"
          defaultChecked={defaultChecked}
        />
      </div>
      <Select
        aria-describedby="errorMessageId"
        hideLabel
        label={selectAriaLabel}
        inputSize="medium"
        theme="wss"
        wrapperProps={{
          className: "w-full px-4",
        }}
        data-testid={selectTestId}
        onChange={onSelectChange}
        defaultValue="0"
      >
        {selectOptions.map((option) => (
          <Option
            key={option.value}
            disabled={option.disabled}
            value={option.value}
          >
            {option.label}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default ReorderOptionGroup;
